/**
 * The fields that ask an emailed link to finish two-factor on the served Page that
 * requested it. A surface that is not a served Page cannot be returned to.
 */
export function inlineTwoFactorFields(
  twoFactor: 'inline' | undefined,
  currentPageId: string | null
): { twoFactor: 'inline'; currentPageId: string } | Record<string, never> {
  return twoFactor === 'inline' && currentPageId ? { twoFactor, currentPageId } : {};
}
